import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { SVGLeft } from "./SVGLeft";
import { SVGRight } from "./SVGRight";
import "./styles.scss";

interface BackgroundProps {
  isNarrow?: boolean;
}

export const Background = ({ isNarrow }: BackgroundProps) => (
  <div
    className={classNames("svg-background", {
      "max-w-[450px]": isNarrow,
      "max-w-[520px]": !isNarrow,
    })}
  >
    <SVGLeft />
    <SVGRight />
  </div>
);
